import http from './http-common';
import {
  GetTenantWorkOrderFormRequest,
  GetTenantWorkOrderFormResponse,
} from 'vendor-marketplace-shared-library';

export const getTenantWorkOrderForm = async (
  input: GetTenantWorkOrderFormRequest,
): Promise<GetTenantWorkOrderFormResponse> => {
  const response = await http.post('/tenant/work-order-form/get', {
    hash: input.hash,
  });
  return response.data;
};
